import { Plus } from 'lucide-react';
import { T } from '../../i18n/copy';
import Reveal from '../Reveal';
import SectionHead from '../SectionHead';

export default function Approach({ lang }) {
  const t = T.approach;
  return (
    <section data-header-theme="bone" data-testid="approach-section" className="editorial-margins bg-bone pb-16 md:pb-20">
      <SectionHead eyebrow={t.eyebrow[lang]} index={t.index} />
      <Reveal className="mt-10">
        <h2 className="max-w-2xl font-tight font-semibold text-[clamp(2rem,4vw,3.6rem)] leading-[1.08] tracking-[-0.02em] text-midnight">
          {t.headline[lang]}
        </h2>
      </Reveal>

      <div className="mt-6 sm:hidden" data-testid="approach-accordion">
        {t.items[lang].map((item, i) => (
          <details key={item.title} data-testid={`approach-mobile-${i}`} className="group border-t border-midnight/12">
            <summary className="flex cursor-pointer list-none items-center gap-3 py-4">
              <span className="eyebrow shrink-0 text-steel-dark">0{i + 1}</span>
              <span className="flex-1 text-base font-medium text-midnight">{item.title}</span>
              <Plus className="h-4 w-4 shrink-0 text-midnight/40 transition-transform duration-200 group-open:rotate-45" strokeWidth={1.5} />
            </summary>
            <p className="pb-5 pr-2 text-base leading-relaxed text-midnight/65">{item.desc}</p>
          </details>
        ))}
      </div>

      <div className="mt-10 hidden gap-x-8 gap-y-8 sm:grid sm:grid-cols-2 lg:grid-cols-4" data-testid="approach-items">
        {t.items[lang].map((item, i) => (
          <Reveal key={item.title} delay={i * 0.07} testid={`approach-item-${i}`}>
            <div className="border-t border-midnight/20 pt-5">
              <span className="eyebrow text-steel-dark">0{i + 1}</span>
              <h3 className="mt-3 text-base font-medium text-midnight">{item.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-midnight/65">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-16" testid="approach-closing">
        <p className="font-serif text-3xl text-midnight md:text-5xl">
          {t.closing[lang].map((w) => (
            <span key={w}>
              {w.slice(0, -1)}
              <span className="text-vermilion">.</span>{' '}
            </span>
          ))}
        </p>
      </Reveal>
    </section>
  );
}
